import React, { useEffect, useState } from 'react'
import { ErrorTost, SuccessTost } from '../../utils/ToastHelper';
import { Apirequests } from '../../utils/ApiRequests';
import { Save, X } from 'lucide-react';
import BtnSpinner from '../../components/BtnSpinner';

function AddEQLead({ setRefresh, close }) {

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        whatsapp_number: "",
        score: "",
        status: ""
    });
    const [loading, setLoading] = useState({ state: false, name: "" });


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        })
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        const { name, email, whatsapp_number, score, status } = formData;

        if (!name || !email || !whatsapp_number || !score || !status) {
            return ErrorTost("Please Provide valid name,email,whatsapp number,score and status.")
        };

        // console.log(formData,'form')
        setLoading({ state: true, name: "addlead" });
        try {
            const addRes = await Apirequests('leads/submit-quiz-lead', 'POST', formData, {});
            // console.log(addRes, 'addres');
            if (addRes?.success) {
                SuccessTost(addRes?.message);
                setRefresh((prev) => !prev);
                close();
            } else {
                ErrorTost(addRes?.message)
            }
        } catch (error) {
            console.log("post new query error");
            ErrorTost("Something went wrong, please try again later.")
        }

        setLoading({ state: false, name: "" })
    };

    useEffect(() => {
        if (formData.score) {
            const { score } = formData;
            const sc= Number(score);
            console.log(score,sc,'stat')

            let stat;
            if (sc >= 5 && sc <= 10) {
                stat = "Low EQ"
            }else if (sc >= 11 && sc <= 15) {
                stat = "Below Average EQ"
            }else if (sc >= 16 && sc <= 20) {
                stat = "Average EQ"
            }else if (sc >= 21 && sc <= 25) {
                stat = "Above Average EQ"
            } else if (sc >= 26 && sc <= 30) {
                stat = "High EQ"
            }else{
                stat="NA"
            };

            setFormData({
                ...formData,
                status:stat
            })

        }
    }, [formData.score]);





    return (
        <div>
            <form onSubmit={handleSubmit} className="bg-white rounded-2xl">

                <div className="flex justify-between items-center mb-2">
                    <h1 className="text-3xl font-bold text-gray-900">
                        Add New EQ Lead
                    </h1>
                </div>
                <div>
                    <div className='mb-2'>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Name *
                        </label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Enter Name"
                        />
                    </div>

                    <div className='mb-2'>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            email *
                        </label>
                        <input
                            type="email"
                            name="email"
                            value={formData?.email}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Enter Email"
                        />
                    </div>

                    <div className='mb-2'>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Whatsapp Number
                        </label>
                        <input
                            type="tel"
                            name="whatsapp_number"
                            value={formData.whatsapp_number}
                            onChange={handleChange}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Enter Whatsapp Number"
                        />
                    </div>

                    <div className='mb-2'>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Score
                        </label>
                        <input
                            type="tel"
                            name="score"
                            value={formData.score}
                            onChange={handleChange}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Enter Score"
                        />
                    </div>
                </div>
                {/* <div className="mb-8">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Query *
                    </label>
                    <textarea
                        name="query"
                        value={formData.query}
                        onChange={handleChange}
                        rows="4"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Enter query"
                    />
                </div> */}

                {/* Form Actions */}
                <div className="flex gap-4">

                    <button
                        type="submit"
                        className="flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors"
                    >
                        {
                            loading.state && loading.name === "addquery" ?
                                <BtnSpinner /> :
                                <>
                                    <Save className="w-5 h-5" />
                                    <span className='text-white'>Add EQ Lead</span>
                                </>
                        }

                    </button>
                    <button
                        type="button"
                        onClick={() => close()}
                        className="flex items-center justify-center gap-2 px-6 py-3 bg-gray-100 text-gray-700 rounded-lg font-semibold hover:bg-gray-200 transition-colors"
                    >
                        <X className="w-5 h-5" />
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    )
}

export default AddEQLead